import MediaApi from '@packages/media/api';

export class MediaBrandingApi extends MediaApi {
    static resource = 'media/branding';
}

export default MediaBrandingApi;
